import { ICommentRequestParamDto } from '../../../services/types';

export enum CommentActionTypes {
  SetDate = 'SET_DATE',
  SetDisplayName = 'SET_DISPLAY_NAME',
  SetUserId = 'SET_USER_ID',
  SetStoryId = 'SET_STORY_ID',
  SetSeasonId = 'SET_SEASON_ID',
  SetCommentId = 'SET_COMMENT_ID',
  SetReviewStatus = 'SET_REVIEW_STATUS',
  SetOrder = 'SET_ORDER',
}

export interface CommentAction {
  type: CommentActionTypes;
  payload: Partial<ICommentRequestParamDto>;
}

const reducer = (state: ICommentRequestParamDto, action: CommentAction): ICommentRequestParamDto => {
  const { type, payload } = action;
  const r = {
    displayName: undefined,
    userId: undefined,
    storyId: undefined,
    seasonId: undefined,
    commentId: undefined,
  };

  switch (type) {
    case CommentActionTypes.SetDate:
      return { ...state, startDate: payload.startDate, endDate: payload.endDate };
    case CommentActionTypes.SetDisplayName:
      return { ...state, ...r, displayName: payload.displayName };
    case CommentActionTypes.SetUserId:
      return { ...state, ...r, userId: payload.userId };
    case CommentActionTypes.SetStoryId:
      return { ...state, ...r, storyId: payload.storyId };
    case CommentActionTypes.SetSeasonId:
      return { ...state, ...r, seasonId: payload.seasonId };
    case CommentActionTypes.SetCommentId:
      return { ...state, ...r, commentId: payload.commentId };
    case CommentActionTypes.SetReviewStatus:
      return { ...state, reviewStatus: payload.reviewStatus };
    case CommentActionTypes.SetOrder:
      return { ...state, order: payload.order };
    default:
      throw new Error();
  }
};

export default reducer;
